import React from 'react';

export const TermsOfService: React.FC = () => {
  const termsOfServiceUrl = "https://docs.google.com/document/d/1EFg_fwcJoOUrp27EaZ1Hi3DIwcrLh7ZbM9Zx0FNhsK4/preview?usp=sharing";

  return (
    <div style={{ display: "flex", height: '90vh' }}>
      <iframe
        src={termsOfServiceUrl}
        style={{ width: '100%', height: '100%' }}
        title="Terms of Service"
      />
    </div>
  );
};
